import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import '../../css/file-upload.css';
import Select from "react-select"; 
import { getFileUploadListFromServer, getFileList } from '../../../../services/demo/alcs/medicalInsuranceFileUploadService';
import { getFileProcessFromServer, getFileProcessFromServerNew } from '../../../../services/demo/alcs/medicalInsuranceReportService';
import axios from "axios";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import { AgGridReact } from 'ag-grid-react';
import LoaderComponent from "../../../../libraries/loader/loader";
import refreshIcon from "../../../../assets/images/refresh.png";
import { baseUrl_1 } from "../../../../services/common/credentials";
import {port, port1} from "../../../../services/auth-service/authService";



const localhost_url = baseUrl_1 + port1;

function MedicalInsuranceFileUpload()
{
    const gridColumnDefs = [
        {field: 'source_type', headerName: 'Source Type', sortable: true, filter: true, resizable: true, width: 130},
        {field: 'file_type', headerName: 'File Type', sortable: true, filter: true, resizable: true, width: 150},
        {field: 'input_date', headerName: 'Input Date', sortable: true, filter: true, resizable: true, width: 100},
        {field: 'extraction_type', headerName: 'Extraction Type', sortable: true, filter: true, resizable: true, width: 125},
        {field: 'file_name', headerName: 'File Name', sortable: true, filter: true, resizable: true, width: 200},
        {field: 'file_size_bytes', headerName: 'File Size (KB)', sortable: true, filter: true, resizable: true, width: 100},
        {field: 'status', headerName: 'Status', sortable: true, filter: true, resizable: true, width: 100},
        {field: 'comments', headerName: 'Comments', sortable: true, filter: true, resizable: true, width: 200},
        {field: 'created_date', headerName:'Upload Date Time', sortable: true, filter: true, resizable: true, width: 200}
    ]

    const [selectedOptions, setSelectedOptions] = useState();
    const [inputMonth, setInputMonth] = useState(undefined);
    const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
    const { register, handleSubmit } = useForm();
    const [columnDefs] = useState(gridColumnDefs);
    const [rowData, setRowData] = useState(undefined);
    const [paginationSize] = useState(15);
    const [loaderOpen, setLoaderOpen] = useState(false);
    const [filetypelist, setFileTypeList] = useState([{ value: "ALL", label: "ALL"},],);	
    const [compltedDateValue, setcompltedDateValue] = useState([]);
    console.log("date", inputMonth,userCredentials)
    useEffect(() => {
	fetch_file_type_list();
        fileUploadsList();
    }, []);

    const optionList = [
        { value: "AXIS_UTR", label: "AXIS_UTR", m_source_id: 1},
        { value: "HDFC_UTR", label: "HDFC_UTR", m_source_id: 2},
        { value: "ICICI_UTR", label: "ICICI_UTR", m_source_id: 3},
        { value: "SBI_UTR", label: "SBI_UTR", m_source_id: 4},
        { value: "AXIS_STATEMENT", label: "AXIS_STATEMENT", m_source_id: 5},
        { value: "HDFC_STATEMENT", label: "HDFC_STATEMENT", m_source_id: 6},
        { value: "ICICI_STATEMENT", label: "ICICI_STATEMENT", m_source_id: 7},
        { value: "SBI_STATEMENT", label: "SBI_STATEMENT", m_source_id: 8},
        { value: "consolidated payment letter", label: "consolidated payment letter", m_source_id: 9},
        { value: "icici nuture utr", label: "icici nuture utr", m_source_id: 10},
        { value: "hdfc reverse utr", label: "hdfc reverse utr", m_source_id: 11},
        
    ];

    const onSubmit = async (data) => {
        
        if (selectedOptions === undefined)
        {
            alert("Please Select a File Type before Upload!!!");
        }
        else if (inputMonth === undefined)
        {
            alert("Please Choose the Date of file before Upload!!!");
        }
        else if (data.file[0] === undefined)
        {
            alert("Please Choose a File for Upload!!!");
        }
        else
        {
            const formData = new FormData();

            formData.append("file", data.file[0]);
            formData.append("file_type", selectedOptions["label"]);
            formData.append("tenants_id", userCredentials["tenants_id"]);
            formData.append("groups_id", userCredentials["groups_id"]);
            formData.append("entities_id", userCredentials["entities_id"]);
            formData.append("user_id", userCredentials["user_id"]);
            formData.append("m_processing_layer_id", userCredentials["m_processing_layer_id"]);
            formData.append("m_processing_sub_layer_id", userCredentials["m_processing_sub_layer_id"]);
            formData.append("processing_layer_id", userCredentials["processing_layer_id"]);
            formData.append("processing_layer_name", "ALCS");
            // formData.append("processing_layer_name", userCredentials["processing_layer_name"]);
            formData.append("source_type", "FILE");
            formData.append("extraction_type", "Upload");
            formData.append("input_date", inputMonth);
            formData.append("type", "post_file_upload");
            formData.append("m_source_id", selectedOptions["m_source_id"]);
            formData.append("is_processing", 0);


            // console.log("Form Data", data.file[0]);
            // console.log("selected", selectedOptions);
            // console.log("Month", inputMonth);
            try
            {
                setLoaderOpen(true);
		console.log('localhost_url', localhost_url);
                const fileUploadResponse = await fetch(localhost_url+"/api/v2/alcs/file_uploads/", {
                    method: "POST",
                    body: formData,
                }).then((res) => res.json());

                console.log("response", fileUploadResponse);
                if (fileUploadResponse["Status"] !== "Success")
                {
                    alert("Error in Uploading File!!!", fileUploadResponse["Status"]);
                    setLoaderOpen(false);
                }
                else
                {
                      fileUploadsList();
                    alert("File Uploaded Successfully!!!");
                    setInputMonth(undefined);
                    setSelectedOptions(undefined);
                    document.getElementById("file-upload-form").reset();
                    document.getElementById("file-upload-month").value = '';
                    setSelectedOptions([]);
                    setLoaderOpen(false);
                }
            }
            catch (err)
            {
                console.log("Error", err);
                setLoaderOpen(false);
            }

            // console.log(JSON.stringify(`${res.message}, status: ${res.status}`));
        }
    };

    function fileUploadsList()
    {
        setLoaderOpen(true);
        let payload = {
            "tenants_id":userCredentials["tenants_id"],
            "entities_id": Array.isArray(userCredentials["selectedentity"]) 
                    ? userCredentials["selectedentity"][0] 
                    : userCredentials["selectedentity"],
            "m_processing_layer_id": 1,
            "m_processing_sub_layer_id": 1,
            "processing_layer_id": 1,
            "is_active": "yes"
        }

        var getFileUploadsList = getFileUploadListFromServer();

        axios.get(getFileUploadsList[1], {params : payload}, getFileUploadsList[0])
        .then(
            response => {
                console.log("File Upload Response!!!", response)
                let data = response["data"];
                console.log('data123456', data);
                if (data)
                {
                    let rowData = data;
                    console.log('rowData'+rowData);
                    if(rowData && rowData.length){
                    for(let i = 0; i < rowData.length; i++)
                    {
                        rowData[i]["file_size_bytes"] = Math.round( rowData[i]["file_size_bytes"] * 0.001 ) / 100;
                    }
                    setRowData(rowData);
                    }
		let completedMonths = rowData
                    .filter(item => item.status === "COMPLETED")
                    .map(item => item.input_date);
					console.log('completedMonths', completedMonths);
                    setcompltedDateValue(completedMonths);
                    setLoaderOpen(false);
                }
		setLoaderOpen(false);
            }
        ).catch(
            error => {
                console.log("Error in File Upload List!!!", error);
                setLoaderOpen(false);
            }
        );

    }

    function handleSelect(data) {
        // console.log(data);
        setSelectedOptions(data);
    }

    const customStyles = {
        control: base => ({
          ...base,
          height: 35,
          minHeight: 35,
          marginTop: 0,
          paddingTop: -5,
          fontSize: 14,
        })
    };

    function searchForm(){
        setLoaderOpen(true);
        console.log(inputMonth);
        let payload = {
            "tenants_id": userCredentials["tenants_id"],
            "groups_id": userCredentials["groups_id"],
            "entities_id": userCredentials["selectedentity"],
            "m_processing_layer_id": 1,
            "m_processing_sub_layer_id": 1,
            "processing_layer_id": 1,
            "is_active": "yes",
            "input_date" : inputMonth,
        }

        
	console.log('payload', payload);
	var getFileProcess;
        getFileProcess = getFileProcessFromServer(); 
        
        axios.post(getFileProcess[1],{params : payload}, getFileProcess[0])
        .then(
            response => {
                console.log("File Process Response!!!", response)
                let data = response["data"];
                console.log("response", data)
                if (data["Status"] === "Success")
                {
                    alert("File Processed Successfully!!!");
                    setLoaderOpen(false);
                }else{
                    setLoaderOpen(false);
                }
            }
        ).catch(
            error => {
                console.log("Error in File Process List!!!", error);
                setLoaderOpen(false);
            }
        );
    }
	
	function fetch_file_type_list(){
        setLoaderOpen(true);
        console.log('userCredentials["entities_id"]', userCredentials["entities_id"]);
        let payload = {   
            "entities_id": userCredentials["entities_id"]  
        }

        var getFileUploadsList = getFileList();
        
        axios.post(getFileUploadsList[1], payload, getFileUploadsList[0])
        .then(
            response => {
                console.log("get file type list", response)
                let data = response["data"];
                let optionList = [
					];
                if (data)
                {
                    for(let key in data){
                        let dict = {
                            value: data[key]["name"],
                            label: data[key]["name"], 
                            m_source_id: data[key]["id"] 
                        }
                        optionList.push(dict);
                    }
                    console.log('optionList1', optionList);
                    setFileTypeList(optionList);
                    setLoaderOpen(false);
                }
            }
        ).catch(
            error => {
                console.log("Error in File Upload List!!!", error);
                setLoaderOpen(false);
            }
        );

    }
	
	const setdatevalue = ({e}) =>{
        let date = e.target.value;
        let dateToCheck = date.toString();
        
        const isDatePresent = compltedDateValue.includes(dateToCheck);
		console.log('compltedDateValue', compltedDateValue);
        if (isDatePresent){
            alert('date is locked!!!');
            setInputMonth(null);
        }else{
            setInputMonth(e.target.value);
        }
        
    }

    return (
        <>
            <div className="file-upload-cardBox">
                <div className="file-upload-card" style={{marginTop: "10px"}}>
                    <div>
                        <label htmlFor="underline_select " className="numbers" style={{fontSize: '15px'}}>File Type</label><br />
                        <div className="cardName">
                            <div className="dropdown-containers">
                                <Select id="file-upload-select"
                                options={filetypelist}
                                placeholder="Select Type"
                                value={selectedOptions}
                                onChange={handleSelect}
                                isSearchable={true}
                                styles = {customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="file-upload-card">
                    <div>
                        <label  id="underline_select" htmlFor="underline_select " className=" numbers" style={{fontSize: '15px'}}>Date</label><br />
                        <input type="date" name="month" value={inputMonth} className="cardName filetype" style={{paddingLeft: "10px"}} onChange={(e) => setdatevalue({ e })} id="file-upload-month" />
                    </div>
                </div>

                <div className="file-upload-card">
                    <div>
                        <label htmlFor="underline_select " className="numbers " style={{fontSize: '15px'}}>File Upload</label><br />
                        <form onSubmit={handleSubmit(onSubmit)} id="file-upload-form">
                            <input type="file" {...register("file")} />
                            <input type="submit" value="Upload" className="btn" style={{height:"35px",marginTop: "-60px",marginLeft:"330px",backgroundColor:"#000055",color:"#ffffff"}} />
                        </form>
                        {/* <button style={{height:"35px",marginTop: "-60px",marginLeft:"330px",backgroundColor:"#000055",color:"#ffffff"}} onClick={searchForm}>
                                        Run
                        </button> */}
                        
                    </div>
                </div>
            

            <div className="file-upload-card">
                <button style={{height:"35px",marginLeft:"61px",marginTop: "13px",backgroundColor:"#000055",color:"#ffffff", width:"20%", borderRadius:"9%"}} onClick={searchForm}>
                                    Run
                </button>
            </div>
            </div>
            <div className="file-upload-layer" style = {{marginTop: "20px",}}>
                <div className="ag-theme-balham fileupload-layer">
                    <AgGridReact
                        columnDefs = {columnDefs}
                        rowData = {rowData}
                        paginationPageSize = {paginationSize}
                        pagination = {true}
                        animateRows = {true}
                    ></AgGridReact>
                </div>
            </div>
            <LoaderComponent loaderOpen = {loaderOpen} />
        </>
    )
}


export default MedicalInsuranceFileUpload;


